import { StyledIllustration } from "@kaltura/mediaspace-shared-ui";
import { translate } from "@kaltura/mediaspace-shared-utils";
import styled from "@emotion/styled";
import { Typography } from "@kaltura/ds-react-components";

const StyledNoMedia = styled("div")({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
});

const NoMedia = () => {
    return (
        <StyledNoMedia>
            <StyledIllustration
                fileName={"no_media.svg"}
                width="300"
                height="300"
                viewBox="0 0 300 300"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <rect
                    x="110.215"
                    y="106.862"
                    width="128.762"
                    height="90.359"
                    rx="8"
                    transform="rotate(-8 110.215 106.862)"
                    className="Primary"
                    fill="#006EFA"
                />
                <rect
                    x="85.3291"
                    y="83.0498"
                    width="121.861"
                    height="86.8885"
                    rx="7"
                    transform="rotate(-8 85.3291 83.0498)"
                    className="Tone8 sTone1"
                    fill="white"
                    stroke="#333333"
                    strokeWidth="2"
                />
                <rect
                    x="61.4014"
                    y="108.725"
                    width="131.021"
                    height="44.05"
                    rx="22.025"
                    transform="rotate(-8 61.4014 108.725)"
                    className="Tone1"
                    fill="#333333"
                />
                <rect
                    x="111.654"
                    y="117.312"
                    width="52.8306"
                    height="2.25898"
                    rx="1.12949"
                    transform="rotate(-8 111.654 117.312)"
                    className="Tone8"
                    fill="white"
                />
                <rect
                    x="113.185"
                    y="128.211"
                    width="22.0128"
                    height="2.25898"
                    rx="1.12949"
                    transform="rotate(-8 113.185 128.211)"
                    className="Tone8"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M72.815 129.439C71.7998 122.216 76.8325 115.537 84.0559 114.522C91.2793 113.507 97.958 118.539 98.9732 125.763C99.9884 132.986 94.9556 139.665 87.7322 140.68C80.5088 141.695 73.8301 136.662 72.815 129.439Z"
                    className="Tone8"
                    fill="white"
                />
                <path
                    d="M80.2208 128.361L84.563 131.678L90.5125 122.506"
                    className="sTone1"
                    stroke="#333333"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle
                    cx="92.2555"
                    cy="215.627"
                    r="18.7382"
                    transform="rotate(-20.3899 92.2555 215.627)"
                    className="Tone1"
                    fill="#333333"
                />
                <path
                    d="M98.9647 212.036C100.452 212.435 100.95 214.294 99.8613 215.382L92.0105 223.233C90.9219 224.322 89.0629 223.824 88.6645 222.337L85.7909 211.612C85.3924 210.125 86.7532 208.764 88.2404 209.163L98.9647 212.036Z"
                    className="Tone8"
                    fill="white"
                />
                <path
                    d="M234.5 259.5C204.407 288.555 157.782 272.051 164.134 219.718C183.132 220.682 194 219.271 194 219.271C189.731 230.5 198 253.5 228 222C247.512 201.513 280.5 199.5 300 209.5L300 246C261.5 230 246.401 248.009 234.5 259.5Z"
                    className="Primary"
                    fill="#006EFA"
                />
                <path
                    d="M178.406 178.772C177.835 180.873 175.018 193.266 174.578 195.819C171.733 193.646 166.025 190.058 158.749 194.188C150.791 198.705 152.581 203.007 153.055 203.9C153.678 205.073 156.759 208.531 160.148 204.489C163.537 200.448 171.726 202.162 170.601 209.11C169.476 216.057 161.238 212.425 158.715 209.067C156.192 205.709 150.895 206.941 151.157 211.593C151.606 219.553 162.22 229.181 173.789 231.562C185.07 233.884 193.434 224.041 195.714 219.698C197.946 215.446 201.797 206.083 205.012 199.704C207.625 194.52 209.35 189.363 206.284 187.834C204.603 186.995 201.837 186.805 199.696 191.006C198.158 194.023 194.844 199.726 192.092 205.467C193.348 200.846 195.789 194.143 197.722 187.033C199.364 180.99 198.777 178.159 196.117 177.436C193.984 176.856 191.766 177.681 188.305 186.738C186.201 192.244 184.019 197.573 182.922 200.381C183.714 195.125 187.035 180.278 187.214 178.494C187.439 176.265 188.17 171.883 183.807 171.079C180.016 170.38 178.999 176.587 178.406 178.772Z"
                    className="Tone1"
                    fill="#333333"
                />
                <path
                    d="M190.704 215.664C187.411 211.215 182.378 209.281 178.869 208.608"
                    className="sTone8"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                />
                <path
                    d="M179.248 222.363C179.219 220.545 178.782 218.83 178.148 217.303C177.915 216.74 177.654 216.203 177.378 215.695"
                    className="sTone8"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M60.859 158.547C61.1269 156.678 59.1377 155.311 57.489 156.232L37.3324 167.485C35.4155 168.556 35.9689 171.451 38.1454 171.738L46.6857 172.867C47.2752 172.945 47.811 173.251 48.1789 173.718L53.7718 180.821C55.0128 182.397 57.5374 181.719 57.822 179.733L60.859 158.547Z"
                    className="Primary"
                    fill="#006EFA"
                />
                <path
                    d="M27.6131 208.092C23.9539 203.869 22.3197 197.26 25.9195 192.189C28.3851 188.716 33.4211 187.419 37.4364 187.266C42.6853 187.067 50.1172 189.036 52.717 194.168C53.7654 196.238 53.1286 199.043 50.8938 199.997C48.4838 201.025 45.4965 199.618 43.9222 197.756C41.8592 195.317 41.4296 191.824 41.5452 188.749C41.6938 184.799 42.4548 180.588 45.1819 176.635C47.909 172.682 51.7181 168.25 51.7181 168.25"
                    className="sTone1"
                    stroke="#333333"
                    strokeWidth="2"
                    strokeLinecap="round"
                />
                <path
                    d="M178.413 50.2461C178.9 45.8548 182.855 42.6901 187.247 43.1777L215.076 46.2672C219.467 46.7547 222.632 50.7098 222.144 55.1011L220.379 71.0034C219.891 75.3947 215.936 78.5593 211.545 78.0718L183.716 74.9823C179.324 74.4947 176.16 70.5397 176.647 66.1484L178.413 50.2461Z"
                    className="Tone1"
                    fill="#333333"
                />
                <path
                    d="M184.376 50.9082L196.958 63.4363C197.589 64.0646 198.559 64.2001 199.338 63.7686L216.181 54.4391"
                    className="sTone8"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </StyledIllustration>

            <Typography variant={"h2"}>{translate("No items are waiting for approval")}</Typography>
        </StyledNoMedia>
    );
};

export default NoMedia;
